export default [
  {
    name: "Sunder",
    class: "III - ursoni",
    lore:
      "Currently classified third in the ursoni designation, 'Sunder' is aptly named for its unrelenting aggressiveness. This primal typically manifests with powerful foreclaws and hind strength capable of propelling the creatur over small buildings. Chosen have described this transformation as 'drowning in an overwhelming sense of anger,' stemming from 'a fierce sense of obligation and defense' of any relation close to them.",
    author: "The Stranton Catalogue",
    attackName: "Slash",
    description: "Sunder reaches out with powerful claws to tear through the opponents in front of him.",
    stats: [
      { name: "Primal Primary Damage", value: "1600" },
      { name: "Primal Primary Range", value: "4.8" },
      { name: "Primal Primary Cooldown", value: "0.4s" },
      { name: "Primal Health", value: "19000" },
      { name: "Primal Movespeed", value: "5.5" },
      { name: "Primal Duration", value: "20s" },
      { name: "Charge Time", value: "300s" },
      { name: "Charge On Pickup", value: "3.5%" },
    ],
    skins: [
      {
        name: "Sunder",
        class: "III - ursoni",
        lore:
          "Currently classified third in the ursoni designation, 'Sunder' is aptly named for its unrelenting aggressiveness. This primal typically manifests with powerful foreclaws and hind strength capable of propelling the creatur over small buildings. Chosen have described this transformation as 'drowning in an overwhelming sense of anger,' stemming from 'a fierce sense of obligation and defense' of any relation close to them.",
        author: "The Stranton Catalogue",
        attackName: "Slash",
        description: "Sunder reaches out with powerful claws to tear through the opponents in front of him.",
        stats: [
          { name: "Primal Primary Damage", value: "1600" },
          { name: "Primal Primary Range", value: "4.8" },
          { name: "Primal Primary Cooldown", value: "0.4s" },
          { name: "Primal Health", value: "19000" },
          { name: "Primal Movespeed", value: "5.5" },
          { name: "Primal Duration", value: "20s" },
          { name: "Charge Time", value: "300s" },
          { name: "Charge On Pickup", value: "3.5%" },
        ],
      },
    ],
  },
  {
    name: "Issia",
    class: "II - gelum",
    lore:
      "Beautiful-of course-but the power! Just the movement of her wings was enough to chill me to the bone. Then...in an instant she pulled ice from the sky like lightning. Issia is often recognized as the patron of 'noble cruelty,' a notion coined by Kryian peasantry to critique the expenditure of one's youth toward the more traditional and burdensome ideals of rural adulthood. Graceful and unwavering, Issia wields incredible power that commands respect, all the while emanating an aura of loneliness and isolation. While in the mask, the sense of confidence and the feeling of truth is paired with an unsettling fear of not knowing exactly how to share it with anyone.",
    author: "The Stranton Catalogue",
    attackName: "Glacial Torrent",
    description: "Issia calls down a deluge of ice in front of her, damaging anything caught in it's path.",
    stats: [
      { name: "Primal Primary Damage", value: "1595" },
      { name: "Primal Primary Range", value: "18" },
      { name: "Primal Primary Cooldown", value: "1s" },
      { name: "Primal Health", value: "17640" },
      { name: "Primal Movespeed", value: "4.4" },
      { name: "Primal Duration", value: "24s" },
      { name: "Charge Time", value: "300s" },
      { name: "Charge On Pickup", value: "3.5%" },
    ],
    skins: [
      {
        name: "Issia",
        class: "II - gelum",
        lore:
          "Beautiful-of course-but the power! Just the movement of her wings was enough to chill me to the bone. Then...in an instant she pulled ice from the sky like lightning. Issia is often recognized as the patron of 'noble cruelty,' a notion coined by Kryian peasantry to critique the expenditure of one's youth toward the more traditional and burdensome ideals of rural adulthood. Graceful and unwavering, Issia wields incredible power that commands respect, all the while emanating an aura of loneliness and isolation. While in the mask, the sense of confidence and the feeling of truth is paired with an unsettling fear of not knowing exactly how to share it with anyone.",
        author: "The Stranton Catalogue",
        attackName: "Glacial Torrent",
        description: "Issia calls down a deluge of ice in front of her, damaging anything caught in it's path.",
        stats: [
          { name: "Primal Primary Damage", value: "1595" },
          { name: "Primal Primary Range", value: "18" },
          { name: "Primal Primary Cooldown", value: "1s" },
          { name: "Primal Health", value: "17640" },
          { name: "Primal Movespeed", value: "4.4" },
          { name: "Primal Duration", value: "24s" },
          { name: "Charge Time", value: "300s" },
          { name: "Charge On Pickup", value: "3.5%" },
        ],
      },
      {
        name: "Luma Issia",
        class: "I,i - aelum",
        lore:
          "Luma variants appear to be connected to the mask-making techniques employed by acolytes of the Sacred Form, an ancient order dedicated to the adoration and worship of primals as divine beings. The Sacred Form's intent to glorify primals in their practice had an unforseen effect on the quality of transformations brought about through their mask work. For Luma Issia specifically, this resulted in new manifestations of power, particularily in the strength of her wings, along with the ability to attack with greater frequency and call down intermittent ground strikes.",
        author: "The Stranton Catalogue",
        attackName: "Glacial Torrent",
        description: "Issia calls down a deluge of ice in front of her, damaging anything caught in it's path.",
        stats: [
          { name: "Primal Primary Damage", value: "1457" },
          { name: "Primal Primary Range", value: "18" },
          { name: "Primal Primary Cooldown", value: "0.7s" },
          { name: "Primal Health", value: "15540" },
          { name: "Primal Movespeed", value: "4.8" },
          { name: "Primal Duration", value: "26s" },
          { name: "Charge Time", value: "300s" },
          { name: "Charge On Pickup", value: "3.5%" },
        ],
      },
    ],
  },
  {
    name: "Nock",
    class: "VII - brer",
    lore: `Full of whimsy, playful antics, and guile, Nock remains a favored subject for children's stories, both new and old. These stories follow a traditional pattern: Nock calls upon a child to play, the child agrees, and a joyous scene ensues only to end abruptly in catastrophic disaster. The undoing of these tales is always Nock's inability to temper her overblown enthusiasm, while the resultant blame for the destruction is placed entirely upon the child by their parent or guardian.`,
    author: "The Stranton Catalogue",
    attackName: "Zoom!",
    description: "Nock dashes in the targeted direction, damaging all enemies she passes through.",
    stats: [
      { name: "Primal Primary Damage", value: "1721" },
      { name: "Primal Primary Range", value: "8.4" },
      { name: "Primal Primary Cooldown", value: "1.2s" },
      { name: "Primal Health", value: "12600" },
      { name: "Primal Movespeed", value: "5.2" },
      { name: "Primal Duration", value: "32s" },
      { name: "Charge Time", value: "300s" },
      { name: "Charge On Pickup", value: "3.5%" },
    ],
    skins: [
      {
        name: "Nock",
        class: "VII - brer",
        lore: `Full of whimsy, playful antics, and guile, Nock remains a favored subject for children's stories, both new and old. These stories follow a traditional pattern: Nock calls upon a child to play, the child agrees, and a joyous scene ensues only to end abruptly in catastrophic disaster. The undoing of these tales is always Nock's inability to temper her overblown enthusiasm, while the resultant blame for the destruction is placed entirely upon the child by their parent or guardian.`,
        author: "The Stranton Catalogue",
        attackName: "Zoom!",
        description: "Nock dashes in the targeted direction, damaging all enemies she passes through.",
        stats: [
          { name: "Primal Primary Damage", value: "1721" },
          { name: "Primal Primary Range", value: "8.4" },
          { name: "Primal Primary Cooldown", value: "1.2s" },
          { name: "Primal Health", value: "12600" },
          { name: "Primal Movespeed", value: "5.2" },
          { name: "Primal Duration", value: "32s" },
          { name: "Charge Time", value: "300s" },
          { name: "Charge On Pickup", value: "3.5%" },
        ],
      },
    ],
  },
  {
    name: "Torden",
    class: "IV - donar",
    lore: `"Do not fear, Torden will save us." Torden sits well within the donar designation, with numerous variants recorded across history. He is regarded as the chief caretaker and protector of agricultural interests. Countless sightings have been reported from the area around Cardum, a region known for its dedication to farming and the culinary arts. The people there have even adopted the primal's stoic distrust for outsiders as an affect of their own, all the while inwardly celebrating a precious respect for community, family, and hearty fellowship. "Laughter, togetherness, and the satisfaction of a meal wrought from the ground... these truths must be protected."`,
    author: "The Stranton Catalogue",
    attackName: "Smash",
    description: "Torden slams his hammer down, dealing damage to a large circular area in front of him.",
    stats: [
      { name: "Primal Primary Damage", value: "4950" },
      { name: "Primal Primary Range", value: "3.2" },
      { name: "Primal Primary Cooldown", value: "0.8s" },
      { name: "Primal Health", value: "25200" },
      { name: "Primal Movespeed", value: "3.8" },
      { name: "Primal Duration", value: "28s" },
      { name: "Charge Time", value: "300s" },
      { name: "Charge On Pickup", value: "3.5%" },
    ],
    skins: [
      {
        name: "Torden",
        class: "IV - donar",
        lore: `"Do not fear, Torden will save us." Torden sits well within the donar designation, with numerous variants recorded across history. He is regarded as the chief caretaker and protector of agricultural interests. Countless sightings have been reported from the area around Cardum, a region known for its dedication to farming and the culinary arts. The people there have even adopted the primal's stoic distrust for outsiders as an affect of their own, all the while inwardly celebrating a precious respect for community, family, and hearty fellowship. "Laughter, togetherness, and the satisfaction of a meal wrought from the ground... these truths must be protected."`,
        author: "The Stranton Catalogue",
        attackName: "Smash",
        description: "Torden slams his hammer down, dealing damage to a large circular area in front of him.",
        stats: [
          { name: "Primal Primary Damage", value: "4950" },
          { name: "Primal Primary Range", value: "3.2" },
          { name: "Primal Primary Cooldown", value: "0.8s" },
          { name: "Primal Health", value: "25200" },
          { name: "Primal Movespeed", value: "3.8" },
          { name: "Primal Duration", value: "28s" },
          { name: "Charge Time", value: "300s" },
          { name: "Charge On Pickup", value: "3.5%" },
        ],
      },
    ],
  },
  {
    name: "Jainx",
    class: "V - buru",
    lore: `To be revealed.`,
    author: "The Stranton Catalogue",
    attackName: "Violent Pierce",
    description:
      "Jainx thrusts his spear forward, dealing damage to all enemies in his path. Upon reaching full extension, the spear releases a small explosion of enegry that deals damage to anything in the area.",
    stats: [
      { name: "Primal Primary Damage", value: "1562" },
      { name: "Primal Primary Range", value: "8.4" },
      { name: "Primal Primary Cooldown", value: "0.7s" },
      { name: "Primal Health", value: "20160" },
      { name: "Primal Movespeed", value: "4.6" },
      { name: "Primal Duration", value: "28s" },
      { name: "Charge Time", value: "300s" },
      { name: "Charge On Pickup", value: "3.5%" },
    ],
    skins: [
      {
        name: "Jainx",
        class: "V - buru",
        lore: `To be revealed.`,
        author: "The Stranton Catalogue",
        attackName: "Violent Pierce",
        description:
          "Jainx thrusts his spear forward, dealing damage to all enemies in his path. Upon reaching full extension, the spear releases a small explosion of enegry that deals damage to anything in the area.",
        stats: [
          { name: "Primal Primary Damage", value: "1562" },
          { name: "Primal Primary Range", value: "8.4" },
          { name: "Primal Primary Cooldown", value: "0.7s" },
          { name: "Primal Health", value: "20160" },
          { name: "Primal Movespeed", value: "4.6" },
          { name: "Primal Duration", value: "28s" },
          { name: "Charge Time", value: "300s" },
          { name: "Charge On Pickup", value: "3.5%" },
        ],
      },
    ],
  },
]
